<template>
  <router-link
    :to="{ name: 'search' }"
    class="logo"
    :aria-label="$t('logo.ariaLabel')"
  >
    <span class="logo__text">Viritin</span>
  </router-link>
</template>

<style lang="scss" scoped>
.logo {
  @include mixins.shadow('down');
  display: inline-block;
  position: absolute;
  top: var(--block-spacing-vertical-normal);
  left: var(--block-spacing-horizontal-normal);
  z-index: 100;
  padding: 0.8em 1.2em;
  font-family: var(--font-sans-serif);
  font-size: 1em;
  font-weight: 900;
  font-style: italic;
  line-height: 1;
  text-transform: uppercase;
  text-decoration: none;
  letter-spacing: -0.02em;
  color: #fff;
  outline: 0;
  background: var(--color-primary);

  &:hover,
  &:focus-visible {
    @media (pointer: fine) {
      text-decoration: underline;
      text-underline-offset: 0.4em;
    }
  }

  @media (min-width: config.$bp-desktop) {
    left: calc(var(--header-size) + var(--block-spacing-horizontal-normal));
    font-size: 1.2em;
  }
}
</style>
